import { render, staticRenderFns } from "./workRecordsPage.vue?vue&type=template&id=47422f6a&"
import script from "./workRecordsPage.vue?vue&type=script&lang=ts&"
export * from "./workRecordsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports